import { Bloom, EffectComposer } from "@react-three/postprocessing";
import { useGameStore } from "../state/useGameStore";

/** Single composer - restrained bloom only where emissive highlights earn it. */
export function PostFX() {
  const climaxActive = useGameStore((s) => s.climaxActive);
  const unlockedIds = useGameStore((s) => s.unlockedIds);
  const coarsePointer = useGameStore((s) => s.coarsePointer);

  const mobile = coarsePointer;
  const late =
    unlockedIds.includes("vein") ||
    unlockedIds.includes("pulse") ||
    unlockedIds.includes("orbit");
  const hot =
    climaxActive ||
    late ||
    unlockedIds.includes("core") ||
    unlockedIds.includes("density");

  const intensity = climaxActive ? 0.85 : late ? 0.62 : hot ? 0.55 : 0.35;
  const threshold = climaxActive ? 0.45 : late ? 0.52 : hot ? 0.55 : 0.65;

  return (
    <EffectComposer
      multisampling={mobile ? 0 : 2}
      resolutionScale={mobile ? 0.5 : 0.75}
      disableNormalPass
    >
      <Bloom
        intensity={intensity}
        luminanceThreshold={threshold}
        luminanceSmoothing={0.75}
        mipmapBlur
      />
    </EffectComposer>
  );
}
